// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { StudentCreateAllOf } from './student-create-all-of';
import { StudentEdit } from './student-edit';

/**
 * 
 * @export
 * @interface StudentCreate
 */
export interface StudentCreate {
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    companyTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    gender?: StudentCreateGenderEnum;
    /**
     * 
     * @type {Date}
     * @memberof StudentCreate
     */
    birthday?: Date;
    /**
     * Additional metadata
     * @type {object}
     * @memberof StudentCreate
     */
    metadata?: object;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentCreate
     */
    photoId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudentCreate
     */
    contractorIds?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum StudentCreateGenderEnum {
    Male = 'male',
    Female = 'female'
}



